import React, { useState, useEffect } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import { Link } from 'react-router-dom';
import NewContractButton from '../components/NewContractButton';
import OtherFormsButton from '../components/OtherFormsButton/OtherFormsButton';
import ContractCard from '../components/ContractCard';
import ContractCard2 from '../components/ContractCard2';
import UploadsList from '../components/Forms/UploadList';
import { useMediaQuery } from 'react-responsive';
import UploadModal from '../components/DocumentUpload/UploadModal';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import config from '../utils/config';
import NavSide from '../components/NavSide'; 

function Forms() {
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('Active');
    const [contracts, setContracts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { token } = useAuth();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const userString = localStorage.getItem('user');
    const userObject = userString ? JSON.parse(userString) : null;
    const email = userObject?.email;

    const statusMapping = {
        'Active': ['completed', 'In Progress', 'partial', 'sent', 'delivered', 'declined', 'voided'],
        'Expired': ['expired', 'terminated'],
    };

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            try {
                const response = await fetch(`${config.apiBaseUrl}/formdata/user`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token || localStorage.getItem('token')}`,
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                const updatedContracts = mapContractsStatus(data);
                setContracts(updatedContracts);
            } catch (error) {
                console.error("Error fetching contracts:", error);
            } finally {
                setIsLoading(false);
            }
        }
        
        fetchData();
    }, [token]);

    function mapContractsStatus(contracts) {
        return contracts.map(contract => {
            if ((contract.data && contract.data.status === 'terminated') ||
            (contract.packetDetails && contract.packetDetails.status === 'terminated')) {
                return { ...contract, status: 'expired' };
            }

            if (contract.packetDetails && contract.packetDetails.documentGroup === null) {
                return { ...contract, status: 'expired' };
            } else if (contract && !contract.packetDetails) {
                return { ...contract, status: 'active' };
            } else {
                return contract;
            }
        });
    }

    const renderContent = () => {
        if (isLoading) {
            return <LoadingSpinner />;
        }

        if (selectedStatus === 'Active' || selectedStatus === 'Expired') {
            const filteredContracts = contracts.filter(contract => {
                if (selectedStatus === 'Active') {
                    return (contract.packetDetails && contract.packetDetails.documentGroup !== null && contract.status !== 'expired') || (contract && !contract.packetDetails);
                } else if (selectedStatus === 'Expired') {
                    return contract.packetDetails && contract.packetDetails.documentGroup === null || contract.status === 'expired';
                }
                return false;
            });

            if (filteredContracts.length === 0) {
                return <p className="text-center w-full mt-8">No forms found</p>;
            }

            return (
                <div className="flex flex-wrap mt-5 md:mt-10 gap-4 md:gap-10 justify-center">
                    {filteredContracts.map(contract => (
                        <ContractCard2 key={contract._id} contractData={contract} />
                    ))}
                </div>
            );
        }

        if (selectedStatus === 'Uploaded') {
            return <UploadsList />;
        }

        return null;
    };

    return (
        <div className="flex min-h-screen">
            {/* <NavSide /> */}
            <div className="flex-1 flex flex-col items-center">
                <div className={`w-full max-w-[1150px] inline-flex justify-between items-center ${!isMobile ? 'sticky top-0 bg-shi-eggshell z-10 py-4' : ''}`}>
                    <div className='inline-flex w-auto flex-col justify-between items-start relative'>
                        <div className='inline-flex justify-between w-full gap-1 md:gap-6'>
                            <div className='flex flex-col items-center'>
                                <button className={`text-black text-[11px] md:text-[14px] ${selectedStatus === 'ACTIVE'}`} onClick={() => setSelectedStatus('Active')}>ACTIVE</button>
                                <div className={`bg-shi-green mt-1 md:mt-3 h-[2px] w-[50px] md:w-[80px] ${selectedStatus !== 'Active' ? 'opacity-0' : ''}`}></div>
                            </div>
                            <div className='flex flex-col items-center'>
                                <button className={`text-black text-[11px] md:text-[14px] ${selectedStatus === 'EXPIRED'}`} onClick={() => setSelectedStatus('Expired')}>EXPIRED</button>
                                <div className={`bg-shi-green mt-1 md:mt-3 h-[2px] w-[50px] md:w-[80px] ${selectedStatus !== 'Expired' ? 'opacity-0' : ''}`}></div>
                            </div>
                            <div className='flex flex-col items-center'>
                                <button className={`text-black text-[11px] md:text-[14px] ${selectedStatus === 'UPLOADED'}`} onClick={() => setSelectedStatus('Uploaded')}>UPLOADS</button>
                                <div className={`bg-shi-green mt-1 md:mt-3 h-[2px] w-[50px] md:w-[80px] ${selectedStatus !== 'Uploaded' ? 'opacity-0' : ''}`}></div>
                            </div>
                        </div>
                    </div>
                    <div className='w-auto mb-1 md:mb-0 md:gap-6 gap-2 justify-end inline-flex'>
                        <OtherFormsButton email={email}/>
                        <>
                            <button 
                                onClick={() => setShowUploadModal(true)}
                                className={`text-[11px] md:text-[13px] md:px-2 md:py-1 p-[2px] text-center rounded-md border border-solid bg-white text-shi-green hover:bg-slate-200 hover:text-white`}
                            >
                                UPLOAD
                            </button>                        
                            <UploadModal
                                isOpen={showUploadModal}
                                onClose={() => setShowUploadModal(false)}
                                onUploadSuccess={(data) => {
                                    setShowUploadModal(false);
                                }}
                            />
                        </>
                        {isMobile ? <NewContractButton email={email} textSize={11}/> : <NewContractButton textSize={13} email={email}/>}
                    </div>
                </div>
                <hr className='w-full max-w-[1150px] md:mt-3'></hr>
                {renderContent()}
            </div>
        </div>
    );
}

export default Forms;